import React, { useState } from "react";
import { toast } from "react-toastify";
import { inviteTenantUser, getToken } from "../../services/user-service";
import { EmailTemplateForInviteSecondaryUser } from "../Emailtemplate";
import "../../pages/user-route/UserDashboard.css";

export default function MultiOrgUserInvite({ userId, onBack }) {
  const [users, setUsers] = useState([]);
  const [fileError, setFileError] = useState("");
  const [sending, setSending] = useState(false);
  const [failedInvites, setFailedInvites] = useState([]);
  const [successCount, setSuccessCount] = useState(0);

  const handleCSVUpload = (e) => {
    setUsers([]);
    setFileError("");

    const file = e.target.files[0];
    if (!file || !file.name.toLowerCase().endsWith(".csv")) {
      setFileError("Please upload a valid CSV file");
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const rows = event.target.result
        .split(/\r?\n/)
        .map((r) => r.trim())
        .filter(Boolean);

      if (rows.length < 2) {
        setFileError("CSV must contain header and at least one row");
        return;
      }

      const parsed = [];

      rows.slice(1).forEach((row) => {
        const cols = row.split(",").map((c) => c.trim());

        const [
          firstName,
          email,
          phoneNo,
          street,
          apartment,
          zipCode,
          city,
          state,
          country,
        ] = cols;

        if (!firstName || !email || !email.includes("@")) return;

        parsed.push({
          userId: null,
          secUserFirstName: firstName || "",
          secUserLastName: "",
          secUserEmail: email || "",
          phoneNo: phoneNo || "",
          street: street || "",
          apartment: apartment || "",
          zipCode: zipCode || "",
          city: city || "",
          state: state || "",
          country: country || "",
          accountType: "primary",
        });
      });

      if (parsed.length === 0) {
        setFileError("No valid users found in CSV");
        return;
      }

      setUsers(parsed);
    };

    reader.readAsText(file);
  };

  const sendInvites = async () => {
    const token = "Bearer " + getToken();
    setSending(true); // 🔵 START DESKTOP LOADING
    let failed = [];
    let success = 0;

    try {
      for (const user of users) {
        const emailDetail = {
          to: user.secUserEmail,
          subject: "ORGANIZATION USER INVITATION",
          message: EmailTemplateForInviteSecondaryUser(
            user.secUserFirstName,
            "",
            "org"
          ),
        };

        const formData = new FormData();
        formData.append("data", JSON.stringify(user));
        formData.append("emailData", JSON.stringify(emailDetail));
        formData.append("tenantUser", "true");

//         await inviteTenantUser(token, formData);
         try {
           await inviteTenantUser(token, formData);
           success++;
         } catch (err) {
           failed.push({
             email: user.secUserEmail,
             reason:
               err?.response?.status === 409
                 ? "Email already exists"
                 : "Invite failed",
           });
         }
      }

//       toast.success(`Invited ${users.length} organization users`);
       toast.success(`Invited ${success} organization users`);
      if (failed.length > 0) {
        toast.warning(
          `Invited ${success} users. ${failed.length} failed.`
        );
      }else {
      onBack();
      }
    } catch (err) {
      console.error(err);
      toast.error("Error sending invitations");
    } finally {
      setSending(false); // 🔵 STOP LOADING
      setFailedInvites(failed);
      setSuccessCount(success);
    }
  };

  return (
    <>
      {sending && (
        <div className="global-loading-overlay">
          <div className="multi-line-spinner"></div>
        </div>
      )}

      <div style={{ padding: "20px", minWidth: "420px" }}>
        <h3>Invite Multiple Organization Users</h3>

        <p>
          <b>CSV Format</b>
        </p>

        <input type="file" accept=".csv" onChange={handleCSVUpload} />

        {fileError && <p style={{ color: "red" }}>{fileError}</p>}

      <div className="invite-btn-group">
        {users.length > 0 && (
          <>
            <p>
              <b>{users.length}</b> users ready to invite
            </p>
            <button className="dashboard_action_btn" onClick={sendInvites}>
              Send Invitations
            </button>
          </>
        )}

        <button
          className="dashboard_action_btn"
          style={{ marginLeft: "10px" }}
          onClick={onBack}
        >
          Cancel
        </button>
        </div>

        {failedInvites.length > 0 && (
          <div style={{ marginTop: "15px", color: "red" }}>
            <h4>Failed Invitations</h4>
            <ul>
              {failedInvites.map((item, index) => (
                <li key={index}>
                  {item.email} — {item.reason}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
}
